<template>
  <div>
    <template v-if="initializing">
      <div class="uk-container">
        <div class="uk-margin" uk-spinner="ratio: 3"></div>
      </div>
    </template>
    <template v-else-if="initializationError">
      <div class="uk-container">
        <p>Error initializing. Please refresh the page.</p>
      </div>
    </template>
    <template v-else>
      <PromotionChangeForm
        :user="user"
        :project="project"
      />
    </template>
  </div>
</template>

<script>
import PromotionChangeForm from '../pages/PromotionChangeForm.vue'
import axios from 'axios'
import swal from 'sweetalert2'
import { serverUrl } from '../../common/helper/serverUrl'

export default {
  components: {
    PromotionChangeForm,
  },

  metaInfo: {
    title: 'Additional Info Form',
  },

  props: ['routeProjectId', 'routeEditToken'],

  data() {
    return {
      initializing: false,
      initializationError: false,

      project: {},
      user: '',
    }
  },

  computed: {
    initializeUrl() {
      return serverUrl('/promotion-change-form/initialize')
    },
  },

  methods: {
    async initialize() {
      this.initializing = true
      axios.get(this.initializeUrl, {
        params: {
          id: this.routeProjectId,
          token: this.routeEditToken,
        },
      })
        .then((resp) => {
          this.project = resp.data.project
          this.user = resp.data.user
        })
        .catch(() => {
          this.initializationError = true
          swal('Error', 'Error initializing. Please refresh the page.', 'error')
        })
        .then(() => {
          this.initializing = false
        })
    },
  },

  created() {
    this.initialize()
  },
}
</script>
